import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';

export const HeaderWrapper = styled.div<{ $isWebView: boolean }>`
  padding-top: ${({ $isWebView }) =>
    $isWebView ? 'calc(0px + max(env(safe-area-inset-top), 40px))' : '0px'};

  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;
